import AddGroupsModal from './AddGroupsModal';

export default AddGroupsModal;
